module.exports = __webpack_public_path__ + "static/media/header.5dd42db7.jpeg";